import React, { useState } from "react";
import brandsStore from "../../store/brands";

import {
  Container,
  ErrorContainer,
  ButtonContainer,
  ConfirmButton,
  CancelButton,
  WarningIcon,
  SelectorContainer,
  StyledSelect,
  StyledSpinner
} from "./styles";

export default props => {
  const { brand, hideModal } = props;
  const {
    data: brands,
    loading: loadingBrands,
    error: errorBrands
  } = brandsStore.useData();
  const selectedBrands = brandsStore.useSelected();
  const {
    loading: editingBrand,
    status: editingStatus,
    error: editingError,
    makeRequest: editBrand
  } = brandsStore.usePutNewData();
  const [value, setValue] = useState();
  const [askForConfirmation, setAskForConfirmation] = useState(false);

  const brandsToUpdate = [...selectedBrands];
  if (!brandsToUpdate.find(sb => sb.mn_brand_id === brand.mn_brand_id))
    brandsToUpdate.push(brand);

  if (editingStatus === 200) hideModal();

  const onConfirm = () => {
    if (!askForConfirmation && brandsToUpdate.length > 1)
      return setAskForConfirmation(true);
    setAskForConfirmation(false);

    editBrand({
      data: brandsToUpdate.map(brand => ({
        ...brand,
        parent_brand_id: value.value
      }))
    });
  };

  const renderError = ({ message, error }) => (
    <ErrorContainer>
      <WarningIcon />
      {message} <p>{error.message}</p>
    </ErrorContainer>
  );

  const renderLoading = ({ message }) => (
    <>
      <StyledSpinner /> {message}
    </>
  );

  const renderSelect = () => {
    const selectParentOptions = brands.map(brand => {
      return {
        label: brand.brand_name,
        value: brand.mn_brand_id
      };
    });

    return (
      <>
        <SelectorContainer>
          Select parent brand
          <StyledSelect
            options={selectParentOptions}
            value={value}
            onChange={setValue}
          />
        </SelectorContainer>
        <ButtonContainer>
          <ConfirmButton onClick={onConfirm}>Confirm</ConfirmButton>
          <CancelButton onClick={hideModal}>Cancel</CancelButton>
        </ButtonContainer>
      </>
    );
  };

  const renderConfirmation = () => {
    return (
      <>
        <p>
          The selected parent brand will be applied to {brandsToUpdate.length}{" "}
          brands. Do you want to continue?
        </p>
        <ButtonContainer>
          <ConfirmButton onClick={onConfirm}>Confirm</ConfirmButton>
          <CancelButton onClick={hideModal}>Cancel</CancelButton>
        </ButtonContainer>
      </>
    );
  };

  const renderContent = () => {
    if (errorBrands)
      return renderError({
        message: "There was an error loading brands",
        error: renderError
      });
    if (editingError)
      return renderError({
        message: "There was an error setting the new parent brand",
        error: editingError
      });
    if (loadingBrands) return renderLoading({ message: "Loading Brands..." });
    if (askForConfirmation) return renderConfirmation();
    if (editingBrand)
      return renderLoading({ message: "Setting the new parent brand..." });
    return renderSelect();
  };

  return <Container>{renderContent()}</Container>;
};
